export default __webpack_public_path__ + "static/media/point-new.47d7259e.svg";